import { UserType as UserTypeEnum, type UserType } from '@dhl/mdp-api'

export const getUserTypeLabel = (userType: UserType) => UserTypeEnum[userType] ?? ''

const businessUserTypes: UserType[] = ['business', 'terminal', 'accountManager']
export const isBusinessUser = (userType: UserType) => businessUserTypes.includes(userType)
